import { render, staticRenderFns } from "./normal-textarea.vue?vue&type=template&id=aee89ae0&scoped=true&"
import script from "./normal-textarea.vue?vue&type=script&lang=js&"
export * from "./normal-textarea.vue?vue&type=script&lang=js&"
import style0 from "./normal-textarea.vue?vue&type=style&index=0&id=aee89ae0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee89ae0",
  null
  
)

export default component.exports